import React, {Component} from "react";
import {Translate} from "react-localize-redux";
import ProductItem from "../../03-components/ProductItem";
import {connect} from "react-redux";
import {getEnv} from "../../env";
import "./style.css";
import {loadFeaturedProducts} from "../../01-actions/adminProducts";
import ProductPanel from "../../03-components/ProductPanel/index";

class FeaturedItems extends Component {
  constructor(props) {
    super(props);
    props.loadFeaturedProducts();
    this.state = {selectedCategoryId: null};
  }

  render() {
    let featuredCategoryIds = this.props.featuredProducts.map(
      (p) => p.categoryId,
    );
    let featuredCategories = this.props.categories.filter(
      (c) => featuredCategoryIds.indexOf(c._id) >= 0,
    );
    let products = this.props.featuredProducts.filter(
      (p) =>
        !this.state.selectedCategoryId ||
        this.state.selectedCategoryId === p.categoryId,
    );

    return (
      <Translate>
        {({translate}) => (
          <div className="con-featureditems">
            <ProductPanel
              className="flex-grow-1 product-list"
              title={translate("featured-items")}
            >
              {products.map((p, index) => {
                let cat = featuredCategories.find(
                  (c) => c._id === p.categoryId,
                );
                return (
                  <ProductItem
                    key={index}
                    id={p._id}
                    categoryId={p.categoryId}
                    category={cat && cat.name}
                    name={p.name}
                    img={getEnv("S3_ASSETS_BUCKET") + "/" + p.img1}
                  />
                );
              })}
            </ProductPanel>
          </div>
        )}
      </Translate>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    featuredProducts: store.adminProducts.featuredProducts,
    categories: store.adminCategories.categories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadFeaturedProducts: () => {
      dispatch(loadFeaturedProducts());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedItems);



// WEBPACK FOOTER //
// ./src/04-containers/FeaturedItems/index.js